import { useCallback } from 'react';
import { isArray, isNil } from 'lodash';
import { isProgrammaticAccount } from 'modules/account-management/accountType';
import { CAMPAIGNS_ROUTE, ENTITY, FORM_MODES } from 'modules/campaigns/config';
import { REPORT_ENTITY_IDS } from 'modules/campaigns/hooks/useReportEntityIds';
import { REPORT_ENTITY_TYPE } from 'modules/campaigns/hooks/useReportEntityType';
import { REPORT_ID } from 'modules/campaigns/modules/campaigns-reports/hooks/useSelectedReportId';
import { useAccount } from 'modules/taboola-common-frontend-modules/account-configurations';
import { mergeQueryParams } from 'modules/taboola-common-frontend-modules/query-params';
import { CAMPAIGN_REPORT_ID } from '../../campaigns-reports/config/reports/campaign/campaignReportId';
import { CREATIVE_REPORT_ID } from '../../campaigns-reports/config/reports/creative/creativeReportId';

const getSelectedCampaignUrl = (campaignId, reportId) =>
    isNil(campaignId)
        ? null
        : `${CAMPAIGNS_ROUTE}${mergeQueryParams({
              [REPORT_ENTITY_IDS]: campaignId,
              [REPORT_ENTITY_TYPE]: ENTITY.CAMPAIGN,
              [REPORT_ID]: reportId,
          })}`;

export const useSelectedCampaignUrl = mode => {
    const account = useAccount();
    const reportId = isProgrammaticAccount(account) ? CAMPAIGN_REPORT_ID : CREATIVE_REPORT_ID;

    const successUrlFunc = useCallback(
        data => {
            if (mode === FORM_MODES.DUPLICATE && isArray(data)) {
                const campaignId = data[0]?.id;
                return getSelectedCampaignUrl(campaignId, reportId);
            }

            if (mode !== FORM_MODES.BULK_EDIT) {
                return CAMPAIGNS_ROUTE;
            }
        },
        [reportId, mode]
    );

    return successUrlFunc;
};
